/**
 * Stable per-tab session id for analytics (survives route changes and
 * reloads within the tab, distinct across tabs). Format: sess_<ts>_<rand>.
 */
const SESSION_KEY = 'aivy_analytics_session_id'

export const getSessionId = () => {
  try {
    let id = window.sessionStorage.getItem(SESSION_KEY)

    if (!id) {
      id = `sess_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`
      window.sessionStorage.setItem(SESSION_KEY, id)
    }

    return id
  } catch {
    // sessionStorage unavailable (iframe/privacy mode) — no session grouping
    return ''
  }
}
